"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withImages = exports.insertImage = void 0;
var react_1 = __importStar(require("react"));
var Ant = __importStar(require("antd"));
var Add_1 = require("@styled-icons/material/Add");
// import * as AppContext from '../AppContext';
var styled_components_1 = __importDefault(require("styled-components"));
var slate_1 = require("slate");
var Storage = __importStar(require("../../Actions/Storage"));
function isHttpUrl(src) {
  // only check if the url starts with http, because not all image url uses
  // file extension as postfix
  var re = /^https?:\/\/.*/g;
  return re.test(src);
}
var UPLOAD_DATA = {
  url: null,
  data: null,
  expected: ''
};
var insertImage = function (editor, url, options) {
  var text = {
    text: ''
  };
  var image = __assign({
    type: 'img',
    src: url,
    children: [text],
    maxWidth: '100%'
  }, options);
  slate_1.Transforms.select(editor, editor._onBlurSelection);
  var hyperLink = (options === null || options === void 0 ? void 0 : options.hypeLinkUrl) || undefined;
  if (hyperLink) {
    var link = {
      type: 'a',
      href: hyperLink,
      children: []
    };
    slate_1.Transforms.wrapNodes(editor, link, {
      split: true
    });
  }
  slate_1.Transforms.insertNodes(editor, image);
  // workaround, let user can select pure text rather than the image block
  var emptyTextNode = {
    type: 'p',
    children: [{
      text: ''
    }]
  };
  slate_1.Transforms.insertNodes(editor, emptyTextNode);
};
exports.insertImage = insertImage;
var withImages = function (editor) {
  var insertData = editor.insertData,
    isVoid = editor.isVoid,
    isInline = editor.isInline;
  editor.isVoid = function (element) {
    return element.type === 'img' ? true : isVoid(element);
  };
  editor.isInline = function (element) {
    return element.type === 'img' && element.hypeLinkUrl ? true : isInline(element);
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    if (isHttpUrl(text)) {
      insertImage(editor, text, {
        width: '100%'
      });
    } else {
      insertData(data);
    }
  };
  return editor;
};
exports.withImages = withImages;
function ImageModal(props) {
  var _this = this;
  var _a = (0, react_1.useState)(props.url || ''),
    imageUrl = _a[0],
    setImageUrl = _a[1];
  var _b = (0, react_1.useState)(UPLOAD_DATA),
    uploadData = _b[0],
    setUploadData = _b[1];
  var _c = (0, react_1.useState)(false),
    loading = _c[0],
    setLoading = _c[1];
  var _d = (0, react_1.useState)({}),
    options = _d[0],
    setOptions = _d[1];
  var visible = props.visible,
    onCancel = props.onCancel,
    onInsert = props.onInsert,
    inContent = props.inContent,
    token = props.token;
  return react_1.default.createElement(Ant.Modal, {
    className: "custom-modal",
    title: "\u65B0\u589E\u5716\u7247\u9023\u7D50",
    visible: visible,
    onCancel: onCancel,
    onOk: function () {
      if (!isHttpUrl(imageUrl)) {
        return alert('這不是圖片網址');
      }
      var hyperLink = (options === null || options === void 0 ? void 0 : options.hypeLinkUrl) || undefined;
      if (hyperLink) {
        if (!isHttpUrl(hyperLink) && hyperLink.indexOf('/') !== 0) {
          return alert('這不是有效的圖片點擊連結');
        }
      }
      onCancel();
      onInsert(imageUrl, options);
      setImageUrl('');
      setUploadData('');
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, react_1.default.createElement(Wrapper, null, react_1.default.createElement(Ant.Upload, {
    className: "image-uploader",
    accept: "image/*",
    action: uploadData.url,
    data: uploadData.data,
    beforeUpload: function (file) {
      return __awaiter(_this, void 0, void 0, function () {
        var resp, err_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setLoading(true);
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, Storage.getUploadUrlFromFile(file, {
                token: token
              })];
            case 2:
              resp = _a.sent();
              setUploadData({
                url: resp.url,
                data: resp.fields,
                expected: resp.expected
              });
              return [3 /*break*/, 4];
            case 3:
              err_1 = _a.sent();
              setLoading(false);
              Ant.message.warning('無法取得上傳路徑');
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    },
    showUploadList: false,
    disabled: loading,
    onChange: function (info) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (info.file.status === 'uploading') {
            // do progressing
            return [2 /*return*/];
          }
          if (info.file.status === 'done') {
            setLoading(false);
            setImageUrl(uploadData.expected);
            return [2 /*return*/];
          }
          return [2 /*return*/];
        });
      });
    }
  }, react_1.default.createElement(UploadWrapper, null, loading ? react_1.default.createElement("div", {
    className: "spinner"
  }) : imageUrl ?
  // <img className="image" src={imageUrl}/>
  react_1.default.createElement(Image, {
    src: imageUrl
  }) : react_1.default.createElement("div", {
    className: "empty"
  }, react_1.default.createElement(Add_1.Add, {
    size: 18,
    color: "#999"
  })))), react_1.default.createElement(Ant.Divider, null, "OR"), react_1.default.createElement("div", {
    style: {
      color: 'gray'
    }
  }, "\u586B\u5165\u5716\u7247\u9023\u7D50"), react_1.default.createElement(Ant.Input, {
    value: imageUrl,
    disabled: loading,
    onChange: function (e) {
      return setImageUrl(e.target.value);
    },
    style: {
      display: 'block',
      width: '100%',
      marginTop: 5,
      marginBottom: 20
    }
  }), react_1.default.createElement(Ant.Divider, null), inContent && react_1.default.createElement(Ant.Radio.Group, {
    defaultValue: "original",
    onChange: function (e) {
      return setOptions(__assign(__assign({}, options), {
        width: e.target.value === 'original' ? undefined : '100%'
      }));
    },
    style: {
      marginBottom: 20
    }
  }, react_1.default.createElement(Ant.Radio, {
    key: "original",
    value: "original"
  }, "\u539F\u59CB\u5927\u5C0F"), react_1.default.createElement(Ant.Radio, {
    key: "max-width",
    value: "max-width"
  }, "\u6700\u5927\u5BEC\u5EA6")), react_1.default.createElement("div", {
    style: {
      color: 'gray'
    }
  }, "\u586B\u5165\u5716\u7247\u9EDE\u64CA\u9023\u7D50"), react_1.default.createElement(Ant.Input, {
    value: options.hypeLinkUrl,
    disabled: loading,
    onChange: function (e) {
      return setOptions(__assign(__assign({}, options), {
        hypeLinkUrl: e.target.value
      }));
    },
    style: {
      display: 'block',
      width: '100%',
      marginTop: 5,
      marginBottom: 20
    }
  })));
}
exports.default = ImageModal;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n  & > .image-uploader {\n    margin: 0 auto;\n  }\n"], ["\n  padding: 20px;\n  & > .image-uploader {\n    margin: 0 auto;\n  }\n"])));
var UploadWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 0 auto;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: solid 1px #eee;\n  & > .empty {\n  }\n  & > .spinner {\n    border: 3px solid white;\n    border-top-color: lightgray;\n    border-radius: 50%;\n    width: 42px;\n    height: 42px;\n    animation: spin 1s linear infinite;\n  }\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 0 auto;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: solid 1px #eee;\n  & > .empty {\n  }\n  & > .spinner {\n    border: 3px solid white;\n    border-top-color: lightgray;\n    border-radius: 50%;\n    width: 42px;\n    height: 42px;\n    animation: spin 1s linear infinite;\n  }\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var Image = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-image: url('", "');\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n"], ["\n  width: 100%;\n  height: 100%;\n  background-image: url('", "');\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n"])), function (props) {
  return props.src;
});
var templateObject_1, templateObject_2, templateObject_3;